import { atom, getDefaultStore } from "jotai";
import { API_URL, } from "./constants";
import { CheckoutUserData, ClassCheckoutDto } from "./domain";
import languageService from "./languageService";


export type FormUserData =
    {
        email: string,
        status: boolean,
        code?: string,
        codeValid?: boolean,
        codeMessage?: string,
        sendingEmail: boolean
    };


const store = getDefaultStore();
export const courseAtom = atom<ClassCheckoutDto | undefined>(undefined);
courseAtom.debugLabel = "courseAtom";

export const userAtom = atom<FormUserData>({ email: "", status: false, sendingEmail: false });
userAtom.debugLabel = "userAtom";

export const endPoints = {
    GET_CLASS_DATA: (id: string) => `${API_URL}/checkout/${id}/data`,
    CHECK_USER: (email: string) => `${API_URL}/login/CheckExistingUser/${email}`,
    CHECK_USER_CODE: (id: string, code: string) => `${API_URL}/checkout/${id}/checkcode/${code}`,
    EMIAL_USER_CODE: (id: string, email: string) => `${API_URL}/checkout/${id}/emailcode/${email}`,
    CHECKOUT_URL: (id: string) => `${API_URL}/checkout/${id}/startcheckout`,
}



export class ClassService {

    public async goToCheckout(values: CheckoutUserData) {
      
        const requestInfo : RequestInit = {
            method: "POST",
            credentials: "include",
            body: JSON.stringify( values ),
            headers: { 'Content-Type': 'application/json' },
        }
        const response = await fetch(
            endPoints.CHECKOUT_URL(this.currentClassId),
            requestInfo
        );

        if( response && response.status === 200){
            const url = await response.json();
            window.location.href = url.Value;
        }


    }

    public currentClassId = "";

    constructor(){
        this.getClassData();
    }

    public async sendCode() {
        const data = { ...store.get(userAtom), sendingEmail: true };
        store.set(userAtom, data);

        const response = await fetch(
            endPoints.EMIAL_USER_CODE(this.currentClassId, data.email),
            {
                method: "POST",
                credentials: 'include'
            }
        );
        if (response) {
            const answ = await response.json();
            if (answ.Value) {
                store.set(userAtom, {
                    ...data,
                    code: undefined,
                    codeValid: false,
                    codeMessage: languageService.getText("code.sent.by.mail", data.email),
                    sendingEmail: false
                });

                return true;
            }

        }

        store.set(userAtom, { ...data, sendingEmail: false });

        return false;
    }

    public async checkCode(code: string) {
        const data = store.get(userAtom);
        if (data.code === code) return data.codeValid;

        const response = await fetch(endPoints.CHECK_USER_CODE(this.currentClassId, code),
            {
                method: 'GET',
                credentials: 'include'
            });

        if (response) {
            const answ = await response.json();
            if (answ.Value) {
                store.set(userAtom, { ...data, codeValid: true });
                return true;
            }
        }
        store.set(userAtom, { ...data, codeValid: false });
        return false;
    }

    resetCode() {
        const data = store.get(userAtom);
        store.set(userAtom, { ...data, code: undefined, codeValid: false });

    }

    public checkEmail(email: string) {

        const data = store.get(userAtom);
        store.set(userAtom, { ...data, email, status: true });
    }



    resetCurrentUser() {
        const data = store.get(userAtom);
        store.set(userAtom, { ...data, email: languageService.getText("email"), status: false });
    }

    private getClassData() {

        const params = new URL(document.location.toString()).searchParams;
        const id = params.get("id");
        if (!id) return;

        fetch(endPoints.GET_CLASS_DATA(id),
            {
                method: 'GET',
                credentials: 'include'
            })
            .then(r => r.json())
            .then(data => {
                store.set(courseAtom, data);
                this.currentClassId = id;

            })
            .catch(e => {
                console.error(e);
            });
    }
}
const classService = new ClassService();
export default classService;